import { forwardRef } from "react";
import "./ScrollableArea.scss";

interface ScrollableAreaProps {
  children: React.ReactNode;
  maxHeight?: string | number;
  height?: string | number;
  showScrollbar?: boolean;
  className?: string;
}

export const ScrollableArea = forwardRef<HTMLDivElement, ScrollableAreaProps>(
  ({ children, maxHeight, height, showScrollbar = true, className = "" }, ref) => {
    const scrollableClass = `scrollable-area ${!showScrollbar ? "scrollbar-hidden" : ""} ${className}`.trim();

    const style = {
      height: height ? (typeof height === "number" ? `${height}px` : height) : undefined,
      maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight,
    };

    return (
      <div ref={ref} className={scrollableClass} style={style}>
        {children}
      </div>
    );
  },
);

ScrollableArea.displayName = "ScrollableArea";
